import { useEffect, useRef, MutableRefObject } from 'react';

type CallBack = () => void;

export default function useOutsideClick<T extends HTMLElement = HTMLElement>(
  callBack: CallBack,
  listenCapturing = true,
): MutableRefObject<T | null> {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        callBack();
      }
    }
    document.addEventListener('click', handleClick, listenCapturing);
    return () => document.removeEventListener('click', handleClick, listenCapturing);
  }, [callBack, listenCapturing]);
  return ref;
}
